var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5243 0.670096C14.4378 0.470065 14.2943 0.299898 14.1118 0.18076C13.9293 0.0616213 13.7157 -0.00123158 13.4978 1.82845e-05H1.12278C0.905048 0.000447303 0.692116 0.064052 0.509817 0.183117C0.327519 0.302181 0.183689 0.471589 0.0957766 0.670788C0.00786385 0.869988 -0.0203539 1.09042 0.0145464 1.30534C0.0494468 1.52026 0.145965 1.72044 0.292393 1.88158L0.298018 1.88791L5.06028 6.97291V12.375C5.06024 12.5786 5.11545 12.7784 5.22003 12.9531C5.32461 13.1278 5.47465 13.2709 5.65414 13.367C5.83362 13.4631 6.03583 13.5087 6.23921 13.499C6.44258 13.4892 6.6395 13.4245 6.80896 13.3116L9.05896 11.8111C9.2132 11.7084 9.33967 11.5691 9.42713 11.4057C9.51459 11.2423 9.56033 11.0599 9.56029 10.8745V6.97291L14.3233 1.88791L14.3289 1.88158C14.4769 1.72117 14.5743 1.52073 14.6091 1.30528C14.6438 1.08982 14.6144 0.868906 14.5243 0.670096ZM8.58857 6.36892C8.49126 6.47209 8.43651 6.60821 8.43528 6.75002V10.8745L6.18528 12.375V6.75002C6.18533 6.60718 6.13103 6.46968 6.03341 6.36541L1.12278 1.12502H13.4978L8.58857 6.36892Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.e58c0f49306c8492397bb8d3cf1a7d14.svg";
export { ForwardRef as ReactComponent };